import { createSlice } from '@reduxjs/toolkit'

const beneficiaryDetailsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: beneficiaryDetailsStatus.LOADING,
    courses: [],
    beneficiary: {},
    errorMessage: null,
}

const beneficiaryDetailsSlice = createSlice({
    name: 'beneficiaryDetails',
    initialState,
    reducers: {
        getBeneficiaryDetailsRequest: state => {
            state.status = beneficiaryDetailsStatus.LOADING
        },
        getBeneficiaryDetailsRequestSuccess: (state, action) => {
            const { beneficiary, courses } = action.payload
            state.courses = courses
            state.beneficiary = beneficiary
            state.status = beneficiaryDetailsStatus.SUCCESS
        },
        getBeneficiaryDetailsRequestError: (state, action) => {
            state.errorMessage = action.payload
            state.status = beneficiaryDetailsStatus.FAILURE
        },
    },
})

const {
    getBeneficiaryDetailsRequest,
    getBeneficiaryDetailsRequestSuccess,
    getBeneficiaryDetailsRequestError,
} = beneficiaryDetailsSlice.actions

export const beneficiaryDetailsActions = {
    getBeneficiaryDetailsRequest,
    getBeneficiaryDetailsRequestSuccess,
    getBeneficiaryDetailsRequestError,
}

export const beneficiaryDetailsSelectors = {
    isFetching: state =>
        state.beneficiaryDetails.status === beneficiaryDetailsStatus.LOADING,
    errorMessage: state => state.beneficiaryDetails.errorMessage,
    hasError: state =>
        state.beneficiaryDetails.status === beneficiaryDetailsStatus.FAILURE,
    courses: state => state.beneficiaryDetails.courses,
    beneficiary: state => state.beneficiaryDetails.beneficiary,
}

export const beneficiaryDetailsReducer = beneficiaryDetailsSlice.reducer
